// extracted by mini-css-extract-plugin
export default {"actions-cell":"UserGroupsListRow_actions-cell__GBw7N"};